import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Link } from "react-router-dom";
import logoNeuroResearch from "@/assets/logo-neuroresearch.webp";

const Footer = () => {
  return (
    <footer className="bg-card border-t border-border py-16">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8 mb-12">
          <div>
            <Link to="/" className="inline-block mb-4">
              <img 
                src={logoNeuroResearch} 
                alt="NeuroResearch Foundation" 
                width={179}
                height={48}
                loading="lazy"
                decoding="async"
                className="h-12 w-auto"
              />
            </Link>
            <p className="text-muted-foreground leading-relaxed">
              Investigando hoy para curar mañana. Dedicados a encontrar soluciones 
              para las enfermedades neurológicas más desafiantes.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-card-foreground">Investigación</h4>
            <ul className="space-y-2 text-muted-foreground">
              <li><Link to="/investigacion-proyectos" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Investigación y Proyectos</Link></li>
              <li><Link to="/colaboraciones" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Colaboraciones</Link></li>
              <li><Link to="/ensayos-clinicos" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Ensayos Clínicos</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-card-foreground">Participar</h4>
            <ul className="space-y-2 text-muted-foreground">
              <li>
                <Link 
                  to="/" 
                  onClick={() => {
                    setTimeout(() => {
                      const donationSection = document.getElementById('donation-section');
                      if (donationSection) {
                        donationSection.scrollIntoView({ behavior: 'smooth' });
                      }
                    }, 100);
                  }}
                  className="hover:text-primary transition-colors"
                >
                  Donar
                </Link>
              </li>
              <li><Link to="/voluntariado" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Voluntariado</Link></li>
              <li><Link to="/eventos" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Eventos</Link></li>
              <li><Link to="/newsletter" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Newsletter</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-card-foreground">Mantente Informado</h4>
            <p className="text-muted-foreground mb-4">
              Suscríbete para recibir actualizaciones sobre nuestra investigación
            </p>
            <div className="flex gap-2">
              <Button 
                variant="secondary"
                asChild
              >
                <Link to="/newsletter">Suscríbete</Link>
              </Button>
            </div>
          </div>
        </div>

        <div className="border-t border-border pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-muted-foreground">
              © 2024 Green Life Bcn Foundation. Todos los derechos reservados.
            </div>
            <div className="flex gap-6 text-muted-foreground">
              <Link to="/privacidad" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Privacidad</Link>
              <Link to="/terminos" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Términos</Link>
              <Link to="/contacto" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Contacto</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;